export function isValidCaptchaSolution(solution) {
    return typeof solution === 'string' && solution !== '' && !solution.startsWith('.')
}

export function readCaptchaSolution(form) {
    if (!form) {
        return ''
    }

    if (isValidCaptchaSolution(form.friendlyCaptchaSolution)) {
        return form.friendlyCaptchaSolution
    }

    return form.querySelector?.('.frc-captcha-solution, input[name="frc-captcha-solution"], input[name="frc-captcha-response"]')?.value || ''
}

const solution = {
    hasCaptchaSolution() {
        return isValidCaptchaSolution(readCaptchaSolution(this.form))
    },

    updateHiddenSolution(solutionValue) {
        const fieldName = this.config?.formFieldName || 'frc-captcha-solution'
        const solutionField = this.form?.querySelector(
            `.frc-captcha-solution, input[name="${fieldName}"], input[name="frc-captcha-solution"], input[name="frc-captcha-response"]`
        )

        if (solutionField) {
            solutionField.value = solutionValue
        }
    },

    isValidCaptchaSolution(solutionValue) {
        return isValidCaptchaSolution(solutionValue)
    }
}

export default solution
